import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_shared/_services/authentication.service';
import { environment } from '@environments/environment';
import { first } from 'rxjs/operators';
import { alert } from 'devextreme/ui/dialog';

@Component({
  selector: 'auth-formsignin',
  templateUrl: './formsignin.component.html',
  styleUrls: ['./formsignin.component.scss']
})
export class AuthentificationFormsigninComponent implements OnInit {

  signinForm: UntypedFormGroup;
  loading = false;
  submitted = false;
  error = '';
  environment = environment;
  @Input() withPassword:boolean;
  @Output() withPasswordChange:EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private formBuilder: UntypedFormBuilder, 
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService) { }

    ngOnInit() {
      this.signinForm = this.formBuilder.group({
          username: ['', Validators.required]
      });
      let username = this.route.snapshot.queryParams.u;

  if(username){
    this.signinForm.controls.username.setValue(username);
}
  }

  // convenience getter for easy access to form fields
  get f() { return this.signinForm.controls; }

  onSubmit($event) {
    $event.stopPropagation();
      this.submitted = true;

      // stop here if form is invalid
      if (this.signinForm.invalid) {
          return;
      }

      this.loading = true;
      this.authenticationService.signin(this.f.username.value)
          .pipe(first())
          .subscribe({
              next: (res) => {

                this.loading = false;
                if(res.msg == "account created"){
                  alert('Votre compte a bien été créé.<br/>Un mail contenant votre mot de passe vous a été envoyé.<br/>Vous allez être redirigé vers la page de connexion','Création du compte')
                  if(!this.route.snapshot.queryParams)
                  this.route.snapshot.queryParams = {};
                  let qp = this.route.snapshot.queryParams;
                  if(this.f?.username?.value)
                  qp = { ...this.route.snapshot.queryParams, u : this.f.username.value}

                  this.router.navigate(["/auth/login"],{queryParams:qp });
                }
                // IF ok
                // go to formverify
                //  this.router.navigate(['/authverify'],{queryParams:this.route.snapshot.queryParams})



                // console.log('ok',this.route.snapshot.queryParams['returnUrl'] )
                //   // get return url from route parameters or default to '/'
                //   const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
                //   this.router.navigate([returnUrl]);
              },
              error: error => {
                if(typeof error === 'object'){
                  this.error = error.msg;
                }
                else{
                  this.error = error;
                }
                if(this.error == "client not exist"){
                  this.error = "Cette adresse email n'existe pas."
                }
                if(this.error == "already exist"){
                  this.error = "Votre compte existe déjà."
                }
                  this.loading = false;
              }
          });

  }
  goBack() {
    if(window){
    window.history.back();
    }
  }
  toggleWithPassword(){
    this.withPassword = !this.withPassword;
    this.withPasswordChange.emit(this.withPassword)
  }

  goToLogin(){
    console.log('goToLogin ?')
    if(!this.route.snapshot.queryParams)
    this.route.snapshot.queryParams = {};
    let qp = this.route.snapshot.queryParams;
    if(this.f?.username?.value)
    qp = { ...this.route.snapshot.queryParams, u : this.f.username.value}

    this.router.navigate(['/auth/login'],{queryParams:qp})
  }

}
